/**
 * "Reference" overview — Reference section (ADR-0074).
 * A consolidated lookup hub that points at every reference-style resource across
 * the docs (CLI reference, MCP reference, framework support, glossary, languages)
 * and adds two cross-cutting quick-reference pages. Links, never duplicates.
 */
import type { DocPageContent } from '../types';

export const REFERENCE_OVERVIEW_PAGE: DocPageContent = {
  slug: 'reference',
  titleKey: 'docs.reference.overview.title',
  descriptionKey: 'docs.reference.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.reference.overview.lead' },

    { kind: 'heading', level: 2, id: 'quick', textKey: 'docs.reference.overview.quick.heading' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.reference.overview.quick.region.term',
          descKey: 'docs.reference.overview.quick.region.desc',
        },
        {
          termKey: 'docs.reference.overview.quick.locales.term',
          descKey: 'docs.reference.overview.quick.locales.desc',
        },
        {
          termKey: 'docs.reference.overview.quick.unit.term',
          descKey: 'docs.reference.overview.quick.unit.desc',
        },
        {
          termKey: 'docs.reference.overview.quick.clients.term',
          descKey: 'docs.reference.overview.quick.clients.desc',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'lookups',
      textKey: 'docs.reference.overview.lookups.heading',
    },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.reference.overview.card.keys.title',
          textKey: 'docs.reference.overview.card.keys.text',
          to: { docSlug: 'reference/key-formats' },
        },
        {
          titleKey: 'docs.reference.overview.card.limits.title',
          textKey: 'docs.reference.overview.card.limits.text',
          to: { docSlug: 'reference/limits' },
        },
        {
          titleKey: 'docs.reference.overview.card.cli.title',
          textKey: 'docs.reference.overview.card.cli.text',
          to: { docSlug: 'cli/reference' },
        },
        {
          titleKey: 'docs.reference.overview.card.mcp.title',
          textKey: 'docs.reference.overview.card.mcp.text',
          to: { docSlug: 'mcp/reference' },
        },
        {
          titleKey: 'docs.reference.overview.card.frameworks.title',
          textKey: 'docs.reference.overview.card.frameworks.text',
          to: { docSlug: 'cli/frameworks' },
        },
        {
          titleKey: 'docs.reference.overview.card.glossary.title',
          textKey: 'docs.reference.overview.card.glossary.text',
          to: { docSlug: 'glossary' },
        },
      ],
    },
  ],
};
